import { FC } from 'react'

import { OrderData } from 'features/Orders/Review/components'
import { Contact } from 'features/Orders/components/Contacts/Contact'

type Props = {
  salesRepresentatives: OrderData['salesRepresentative'][]
}

export const SalesRepList: FC<Props> = ({ salesRepresentatives }) => (
  <>
    {salesRepresentatives?.map((salesRep: OrderData['salesRepresentative']) => (
      <Contact
        title="Sales Rep"
        key={salesRep?.id}
        name={salesRep?.displayName || undefined}
        email={salesRep?.email || undefined}
      />
    ))}
  </>
)
